
    <div class="br-confirm-dialog">
      <header class="br-dialog-header">
        <h2 class="br-dialog-title">{{ data.title }}</h2>
      </header>

      <mat-dialog-content class="br-dialog-body br-confirm-dialog__body">
        <p>{{ data.message }}</p>
        <p id="typed-confirmation-prompt">
          Type <strong>{{ data.confirmationText }}</strong> (Case Sensitive) to confirm.
        </p>
        <div class="br-confirm-dialog__field">
          <label class="br-form-label" for="typed-confirmation-input">Confirmation</label>
          <input
              id="typed-confirmation-input"
              class="br-form-control br-form-control--sm"
              [(ngModel)]="typedValue"
              [attr.aria-describedby]="'typed-confirmation-prompt'"
              autocomplete="off"
              spellcheck="false">
        </div>
      </mat-dialog-content>

      <footer class="br-dialog-footer">
        <button
            type="button"
            class="br-btn br-btn--outline-secondary br-btn--sm"
            [mat-dialog-close]="false">
          Cancel
        </button>
        <button
            type="button"
            class="br-btn br-btn--danger br-btn--sm"
            [disabled]="typedValue !== data.confirmationText"
            [mat-dialog-close]="true">
          {{ data.confirmLabel }}
        </button>
      </footer>
    </div>
